export const HANDLE_AUTH_INPUT = 'HANDLE_INPUT';
export const HANDLE_AUTH_SUBMIT = 'HANDLE_AUTH_SUBMIT';
export const HANDLE_AUTH_SUCCESS = 'HANDLE_AUTH_SUCCESS';
export const HANDLE_AUTH_FAILED = 'HANDLE_AUTH_FAILED';
export const HANDLE_CLEAR_AUTH_STATE = 'HANDLE_CLEAR_AUTH_STATE';
export const CURRENT_USER_FOUND = 'CURRENT_USER_FOUND';
export const CURRENT_USER_NOT_FOUND = 'CURRENT_USER_NOT_FOUND';
export const CHECKING_CURRENT_USER = 'CHECKING_CURRENT_USER';
export const REMOVE_CURRENT_USER = 'REMOVE_CURRENT_USER';
/** Password update and reset */
export const HANDLE_PASSWORD_RESET_REQUEST = 'HANDLE_PASSWORD_RESET_REQUEST';
export const HANDLE_PASSWORD_RESET_REQUEST_SUCCESS = 'HANDLE_PASSWORD_RESET_REQUEST_SUCCESS';
export const HANDLE_PASSWORD_RESET_REQUEST_FAILED = 'HANDLE_PASSWORD_RESET_REQUEST_FAILED';
/** Books actions types */
export const FETCHING_ALL_BOOKS = 'FETCHING_ALL_BOOKS';
export const FETCHING_ALL_BOOKS_SUCCESS = 'FETCHING_ALL_BOOKS_SUCCESS';
export const FETCHING_ALL_BOOKS_FAILED = 'FETCHING_ALL_BOOKS_FAILED';
export const HANDLE_PAGINATION = 'HANDLE_PAGINATION';
export const HANDLE_PAGINATION_ENDED = 'HANDLE_PAGINATION_ENDED';
/** Edit profile */
export const EDIT_PROFILE_INPUT_CHANGE = 'EDIT_PROFILE_INPUT_CHANGE';
export const EDIT_PROFILE_FAILED = 'EDIT_PROFILE_FAILED';
export const UPDATE_USER_AVATAR = 'UPDATE_USER_PROFILE';
export const UPDATING_USER = 'UPDATING_USER';
